var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMindwaveLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 260 34",
    style: {
      enableBackground: "new 0 0 260 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00A973;}\n\t.st1{fill:#686A6B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_59_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_104_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_105_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_106_",
    className: "st0",
    d: "M48.3,31.7c-0.4,0-0.8-0.2-1.1-0.5c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.4,0.2-0.8,0.5-1.1 c0.6-0.6,1.6-0.6,2.2,0c0.3,0.3,0.5,0.7,0.5,1.1c0,0.4-0.2,0.8-0.5,1.1C49.1,31.5,48.7,31.7,48.3,31.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_96_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_97_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_98_",
    className: "st0",
    d: "M44.9,26.3c-0.3-0.8,0-1.7,0.8-2.1l0,0c0.8-0.3,1.7,0,2.1,0.8l0,0c0.3,0.8,0,1.7-0.8,2.1 l0,0c-0.2,0.1-0.4,0.1-0.6,0.1l0,0C45.8,27.2,45.2,26.9,44.9,26.3z M43,21.8c-0.3-0.8,0-1.7,0.8-2.1l0,0c0.8-0.3,1.7,0,2.1,0.8 l0,0c0.3,0.8,0,1.7-0.8,2.1l0,0c-0.2,0.1-0.4,0.1-0.6,0.1l0,0C43.8,22.8,43.2,22.4,43,21.8z M41,17.4c-0.3-0.8,0-1.7,0.8-2.1 l0,0c0.8-0.3,1.7,0,2.1,0.8l0,0c0.3,0.8,0,1.7-0.8,2.1l0,0c-0.2,0.1-0.4,0.1-0.6,0.1l0,0C41.9,18.3,41.3,18,41,17.4z M39.1,12.9 c-0.3-0.8,0-1.7,0.8-2.1l0,0c0.8-0.3,1.7,0,2.1,0.8l0,0c0.3,0.8,0,1.7-0.8,2.1l0,0c-0.2,0.1-0.4,0.1-0.6,0.1l0,0 C40,13.9,39.4,13.5,39.1,12.9z M37.2,8.5c-0.3-0.8,0-1.7,0.8-2.1l0,0c0.8-0.3,1.7,0,2.1,0.8l0,0c0.3,0.8,0,1.7-0.8,2.1l0,0 c-0.2,0.1-0.4,0.1-0.6,0.1l0,0C38,9.4,37.4,9.1,37.2,8.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_93_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_94_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_95_",
    className: "st0",
    d: "M36.7,5c-0.4,0-0.8-0.2-1.1-0.5c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.4,0.2-0.8,0.5-1.1 c0.6-0.6,1.6-0.6,2.2,0c0.3,0.3,0.5,0.7,0.5,1.1c0,0.4-0.2,0.8-0.5,1.1C37.5,4.8,37.1,5,36.7,5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_85_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_87_",
    className: "st0",
    d: "M26.8,27.1c-0.8-0.3-1.2-1.3-0.8-2.1l0,0c0.3-0.8,1.3-1.2,2.1-0.9l0,0 c0.8,0.3,1.2,1.3,0.8,2.1l0,0c-0.2,0.6-0.8,1-1.5,1l0,0C27.2,27.2,27,27.2,26.8,27.1z M28.7,22.7c-0.8-0.3-1.2-1.3-0.8-2.1l0,0 c0.3-0.8,1.3-1.2,2.1-0.9l0,0c0.8,0.3,1.2,1.3,0.8,2.1l0,0c-0.3,0.6-0.8,1-1.5,1l0,0C29.1,22.8,28.9,22.8,28.7,22.7z M30.5,18.2 c-0.8-0.3-1.2-1.3-0.8-2.1l0,0c0.3-0.8,1.3-1.2,2.1-0.8l0,0c0.8,0.3,1.2,1.3,0.9,2.1l0,0c-0.3,0.6-0.8,1-1.5,1l0,0 C30.9,18.3,30.7,18.3,30.5,18.2z M32.4,13.8c-0.8-0.3-1.2-1.3-0.8-2.1l0,0c0.3-0.8,1.3-1.2,2.1-0.8l0,0c0.8,0.3,1.2,1.3,0.8,2.1 l0,0c-0.3,0.6-0.8,1-1.5,1l0,0C32.8,13.9,32.6,13.8,32.4,13.8z M34.3,9.3c-0.8-0.3-1.2-1.3-0.9-2.1h0c0.3-0.8,1.3-1.2,2.1-0.8 l0,0c0.8,0.3,1.2,1.3,0.8,2.1l0,0l0,0l0,0c-0.3,0.6-0.8,1-1.5,1l0,0C34.7,9.4,34.4,9.4,34.3,9.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_82_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_83_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_84_",
    className: "st0",
    d: "M25.6,31.7c-0.4,0-0.8-0.2-1.1-0.5c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.4,0.2-0.8,0.5-1.1 c0.6-0.6,1.6-0.6,2.2,0c0.3,0.3,0.5,0.7,0.5,1.1c0,0.4-0.2,0.8-0.5,1.1C26.4,31.5,26,31.7,25.6,31.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_74_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_75_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_76_",
    className: "st0",
    d: "M22.2,26.3c-0.3-0.8,0-1.7,0.8-2.1l0,0c0.8-0.3,1.7,0,2.1,0.8l0,0c0.3,0.8,0,1.7-0.8,2.1 l0,0c-0.2,0.1-0.4,0.1-0.6,0.1l0,0C23,27.2,22.5,26.9,22.2,26.3z M20.3,21.8c-0.3-0.8,0-1.7,0.8-2.1l0,0c0.8-0.3,1.7,0,2.1,0.8 l0,0c0.3,0.8,0,1.7-0.8,2.1l0,0c-0.2,0.1-0.4,0.1-0.6,0.1l0,0C21.1,22.8,20.5,22.4,20.3,21.8z M18.4,17.4 c-0.3-0.8,0-1.7,0.8-2.1l0,0c0.8-0.3,1.7,0,2.1,0.8l0,0c0.3,0.8,0,1.7-0.8,2.1l0,0c-0.2,0.1-0.4,0.1-0.6,0.1l0,0 C19.2,18.3,18.6,18,18.4,17.4z M16.4,12.9c-0.3-0.8,0-1.7,0.8-2.1l0,0c0.8-0.3,1.7,0,2.1,0.8l0,0c0.3,0.8,0,1.7-0.8,2.1l0,0 c-0.2,0.1-0.4,0.1-0.6,0.1l0,0C17.3,13.9,16.7,13.5,16.4,12.9z M14.5,8.5c-0.3-0.8,0-1.7,0.8-2.1l0,0c0.8-0.3,1.7,0,2.1,0.8l0,0 c0.3,0.8,0,1.7-0.8,2.1l0,0c-0.2,0.1-0.4,0.1-0.6,0.1l0,0C15.3,9.4,14.8,9.1,14.5,8.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_71_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_72_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_73_",
    className: "st0",
    d: "M14,5c-0.4,0-0.8-0.2-1.1-0.5c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.4,0.2-0.8,0.5-1.1 c0.6-0.6,1.6-0.6,2.2,0c0.3,0.3,0.5,0.7,0.5,1.1c0,0.4-0.2,0.8-0.5,1.1C14.8,4.8,14.4,5,14,5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_63_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_64_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    className: "st0",
    d: "M4.1,27.1C3.3,26.8,3,25.8,3.3,25l0,0c0.3-0.8,1.3-1.2,2.1-0.9l0,0c0.8,0.3,1.2,1.3,0.8,2.1 l0,0c-0.3,0.6-0.8,1-1.5,1l0,0C4.5,27.2,4.3,27.2,4.1,27.1z M6,22.7c-0.8-0.3-1.2-1.3-0.8-2.1l0,0c0.3-0.8,1.3-1.2,2.1-0.8l0,0 C8,20.1,8.4,21,8.1,21.8l0,0c-0.3,0.6-0.8,1-1.5,1l0,0C6.4,22.8,6.2,22.7,6,22.7z M7.8,18.2C7,17.9,6.7,16.9,7,16.1l0,0 c0.3-0.8,1.3-1.2,2.1-0.8l0,0c0.8,0.3,1.2,1.3,0.8,2.1l0,0c-0.3,0.6-0.8,1-1.5,1l0,0C8.2,18.3,8,18.3,7.8,18.2z M9.7,13.8 c-0.8-0.3-1.2-1.3-0.8-2.1l0,0c0.3-0.8,1.3-1.2,2.1-0.9l0,0c0.8,0.3,1.2,1.3,0.8,2.1l0,0c-0.2,0.6-0.8,1-1.5,1l0,0 C10.1,13.9,9.9,13.8,9.7,13.8z M11.5,9.3c-0.8-0.3-1.2-1.3-0.8-2.1l0,0C11,6.4,12,6.1,12.8,6.4l0,0c0.8,0.3,1.2,1.3,0.9,2.1l0,0 c-0.3,0.6-0.8,1-1.5,1l0,0C12,9.4,11.8,9.4,11.5,9.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_60_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_61_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_62_",
    className: "st0",
    d: "M2.9,31.7c-0.4,0-0.8-0.2-1.1-0.5c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.4,0.2-0.8,0.5-1.1 c0.6-0.6,1.6-0.6,2.2,0c0.3,0.3,0.5,0.7,0.5,1.1c0,0.4-0.2,0.8-0.5,1.1C3.7,31.5,3.3,31.7,2.9,31.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_53_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    className: "st1",
    d: "M58.7,1.7c-0.8,0-1.5,0.7-1.5,1.5v27.7c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5V3.2 C60.2,2.4,59.5,1.7,58.7,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_57_",
    className: "st1",
    d: "M95.1,1.5c-0.9,0-1.5,0.7-1.5,1.5v23.6L73.8,2.4c-0.4-0.5-0.9-0.8-1.5-0.8H72 c-0.9,0-1.6,0.7-1.6,1.5v27.6c0,0.8,0.7,1.5,1.5,1.5c0.9,0,1.5-0.7,1.5-1.5V6.6l20.1,24.7c0.3,0.4,0.8,0.9,1.5,0.9h0.2 c0.8,0,1.4-0.6,1.4-1.4V3C96.6,2.2,95.9,1.5,95.1,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    className: "st1",
    d: "M114.9,1.8h-7.3c-0.7,0-1.4,0.7-1.4,1.5v27.4c0,0.8,0.6,1.5,1.4,1.5h7.3 c7.9,0,13.6-6.4,13.6-15.2V17C128.5,8.2,122.8,1.8,114.9,1.8z M125.7,17L125.7,17c0,7.3-4.5,12.3-10.8,12.3h-6V4.7h6 C121.1,4.7,125.7,9.9,125.7,17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_49_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    className: "st1",
    d: "M194.1,3c-0.3-0.8-0.9-1.2-1.6-1.2h-0.1c-0.8,0-1.3,0.4-1.6,1.2l-11.4,27.2 c-0.1,0.3-0.1,0.4-0.1,0.6c0,0.8,0.7,1.4,1.4,1.4c0.6,0,1.1-0.4,1.4-1.1L192.3,6l10.2,25.1c0.3,0.7,0.8,1.2,1.5,1.2 c0.9,0,1.5-0.8,1.5-1.5c0-0.2,0-0.4-0.1-0.6L194.1,3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st1",
    d: "M232,1.8c-0.6,0-1.1,0.4-1.4,1.1L220.3,28L210,3c-0.3-0.7-0.8-1.2-1.5-1.2 c-0.9,0-1.5,0.8-1.5,1.5c0,0.2,0,0.4,0.1,0.6L218.6,31c0.3,0.8,0.9,1.2,1.6,1.2h0.1c0.8,0,1.3-0.4,1.6-1.2l11.4-27.2 c0.1-0.3,0.1-0.4,0.1-0.6C233.5,2.5,232.8,1.8,232,1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st1",
    d: "M257.4,29.3h-14V5h13.8c0.7,0,1.2-0.6,1.2-1.4c0-0.8-0.6-1.4-1.2-1.4h-15.1 c-0.7,0-1.3,0.7-1.3,1.5v27c0,0.8,0.6,1.5,1.3,1.5h15.3c0.7,0,1.2-0.6,1.2-1.4C258.7,29.9,258.1,29.3,257.4,29.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_46_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_47_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    className: "st0",
    d: "M133.3,1.9c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.5,0.7,0.5,1.1c0,0.4-0.2,0.8-0.5,1.1 c-0.6,0.6-1.6,0.6-2.2,0c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.4,0.2-0.8,0.5-1.1C132.5,2,132.9,1.9,133.3,1.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_38_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_39_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    className: "st0",
    d: "M136.7,7.3c0.3,0.8,0,1.7-0.8,2.1l0,0c-0.8,0.3-1.7,0-2.1-0.8l0,0c-0.3-0.8,0-1.7,0.8-2.1 l0,0c0.2-0.1,0.4-0.1,0.6-0.1l0,0C135.9,6.3,136.5,6.7,136.7,7.3z M138.6,11.7c0.3,0.8,0,1.7-0.8,2.1l0,0 c-0.8,0.3-1.7,0-2.1-0.8l0,0c-0.3-0.8,0-1.7,0.8-2.1l0,0c0.2-0.1,0.4-0.1,0.6-0.1l0,0C137.8,10.8,138.4,11.1,138.6,11.7z  M140.6,16.1c0.3,0.8,0,1.7-0.8,2.1l0,0c-0.8,0.3-1.7,0-2.1-0.8l0,0c-0.3-0.8,0-1.7,0.8-2.1l0,0c0.2-0.1,0.4-0.1,0.6-0.1l0,0 C139.7,15.2,140.3,15.6,140.6,16.1z M142.5,20.6c0.3,0.8,0,1.7-0.8,2.1l0,0c-0.8,0.3-1.7,0-2.1-0.8l0,0c-0.3-0.8,0-1.7,0.8-2.1 l0,0c0.2-0.1,0.4-0.1,0.6-0.1l0,0C141.7,19.6,142.2,20,142.5,20.6z M144.4,25c0.3,0.8,0,1.7-0.8,2.1l0,0c-0.8,0.3-1.7,0-2.1-0.8 l0,0c-0.3-0.8,0-1.7,0.8-2.1l0,0c0.2-0.1,0.4-0.1,0.6-0.1l0,0C143.6,24.1,144.2,24.4,144.4,25z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_35_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_36_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st0",
    d: "M144.9,28.5c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.5,0.7,0.5,1.1c0,0.4-0.2,0.8-0.5,1.1 c-0.6,0.6-1.6,0.6-2.2,0c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.4,0.2-0.8,0.5-1.1C144.1,28.7,144.5,28.5,144.9,28.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_27_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st0",
    d: "M154.8,6.4c0.8,0.3,1.2,1.3,0.8,2.1l0,0c-0.3,0.8-1.3,1.2-2.1,0.9l0,0 c-0.8-0.3-1.2-1.3-0.8-2.1l0,0c0.2-0.6,0.8-1,1.5-1l0,0C154.4,6.3,154.6,6.3,154.8,6.4z M152.9,10.9c0.8,0.3,1.2,1.3,0.8,2.1 l0,0c-0.3,0.8-1.3,1.2-2.1,0.9l0,0c-0.8-0.3-1.2-1.3-0.8-2.1l0,0c0.3-0.6,0.8-1,1.5-1l0,0C152.5,10.7,152.7,10.8,152.9,10.9z  M151.1,15.3c0.8,0.3,1.2,1.3,0.8,2.1l0,0c-0.3,0.8-1.3,1.2-2.1,0.8l0,0c-0.8-0.3-1.2-1.3-0.9-2.1l0,0c0.3-0.6,0.8-1,1.5-1l0,0 C150.7,15.2,150.9,15.2,151.1,15.3z M149.2,19.8c0.8,0.3,1.2,1.3,0.8,2.1l0,0c-0.3,0.8-1.3,1.2-2.1,0.8l0,0 c-0.8-0.3-1.2-1.3-0.8-2.1l0,0c0.3-0.6,0.8-1,1.5-1l0,0C148.8,19.6,149,19.7,149.2,19.8z M147.4,24.2c0.8,0.3,1.2,1.3,0.9,2.1h0 c-0.3,0.8-1.3,1.2-2.1,0.8l0,0c-0.8-0.3-1.2-1.3-0.8-2.1l0,0l0,0l0,0c0.3-0.6,0.8-1,1.5-1l0,0C147,24.1,147.2,24.1,147.4,24.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_24_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_25_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st0",
    d: "M156,1.9c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.5,0.7,0.5,1.1c0,0.4-0.2,0.8-0.5,1.1 c-0.6,0.6-1.6,0.6-2.2,0c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.4,0.2-0.8,0.5-1.1C155.2,2,155.6,1.9,156,1.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st0",
    d: "M159.4,7.3c0.3,0.8,0,1.7-0.8,2.1l0,0c-0.8,0.3-1.7,0-2.1-0.8l0,0c-0.3-0.8,0-1.7,0.8-2.1 l0,0c0.2-0.1,0.4-0.1,0.6-0.1l0,0C158.6,6.3,159.2,6.7,159.4,7.3z M161.3,11.7c0.3,0.8,0,1.7-0.8,2.1l0,0 c-0.8,0.3-1.7,0-2.1-0.8l0,0c-0.3-0.8,0-1.7,0.8-2.1l0,0c0.2-0.1,0.4-0.1,0.6-0.1l0,0C160.5,10.8,161.1,11.1,161.3,11.7z  M163.3,16.1c0.3,0.8,0,1.7-0.8,2.1l0,0c-0.8,0.3-1.7,0-2.1-0.8l0,0c-0.3-0.8,0-1.7,0.8-2.1l0,0c0.2-0.1,0.4-0.1,0.6-0.1l0,0 C162.4,15.2,163,15.6,163.3,16.1z M165.2,20.6c0.3,0.8,0,1.7-0.8,2.1l0,0c-0.8,0.3-1.7,0-2.1-0.8l0,0c-0.3-0.8,0-1.7,0.8-2.1 l0,0c0.2-0.1,0.4-0.1,0.6-0.1l0,0C164.4,19.6,164.9,20,165.2,20.6z M167.1,25c0.3,0.8,0,1.7-0.8,2.1l0,0c-0.8,0.3-1.7,0-2.1-0.8 l0,0c-0.3-0.8,0-1.7,0.8-2.1l0,0c0.2-0.1,0.4-0.1,0.6-0.1l0,0C166.3,24.1,166.9,24.4,167.1,25z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st0",
    d: "M167.6,28.5c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.5,0.7,0.5,1.1c0,0.4-0.2,0.8-0.5,1.1 c-0.6,0.6-1.6,0.6-2.2,0c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.4,0.2-0.8,0.5-1.1C166.8,28.7,167.2,28.5,167.6,28.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M177.5,6.4c0.8,0.3,1.2,1.3,0.8,2.1l0,0c-0.3,0.8-1.3,1.2-2.1,0.9l0,0 c-0.8-0.3-1.2-1.3-0.8-2.1l0,0c0.3-0.6,0.8-1,1.5-1l0,0C177.1,6.3,177.3,6.3,177.5,6.4z M175.6,10.9c0.8,0.3,1.2,1.3,0.8,2.1 l0,0c-0.3,0.8-1.3,1.2-2.1,0.8l0,0c-0.8-0.3-1.2-1.3-0.9-2.1l0,0c0.3-0.6,0.8-1,1.5-1l0,0C175.2,10.7,175.4,10.8,175.6,10.9z  M173.8,15.3c0.8,0.3,1.2,1.3,0.9,2.1l0,0c-0.3,0.8-1.3,1.2-2.1,0.8l0,0c-0.8-0.3-1.2-1.3-0.8-2.1l0,0c0.3-0.6,0.8-1,1.5-1l0,0 C173.4,15.2,173.6,15.2,173.8,15.3z M171.9,19.8c0.8,0.3,1.2,1.3,0.8,2.1l0,0c-0.3,0.8-1.3,1.2-2.1,0.9l0,0 c-0.8-0.3-1.2-1.3-0.8-2.1l0,0c0.2-0.6,0.8-1,1.5-1l0,0C171.5,19.6,171.7,19.7,171.9,19.8z M170.1,24.2c0.8,0.3,1.2,1.3,0.8,2.1 l0,0c-0.3,0.8-1.3,1.2-2.1,0.8l0,0c-0.8-0.3-1.2-1.3-0.9-2.1l0,0c0.3-0.6,0.8-1,1.5-1l0,0C169.7,24.1,169.9,24.1,170.1,24.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st0",
    d: "M178.7,1.9c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.5,0.7,0.5,1.1c0,0.4-0.2,0.8-0.5,1.1 c-0.6,0.6-1.6,0.6-2.2,0c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.4,0.2-0.8,0.5-1.1C177.9,2,178.3,1.9,178.7,1.9z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindwaveLogo);
export default __webpack_public_path__ + "static/media/mindwave-logo.b0b9fb73aeff97cda5ada053a3871431.svg";
export { ForwardRef as ReactComponent };